import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

import MediaBrowserService from '../mediaBrowser/MediaBrowserService.jsx';

var ImageadWidget = createReactClass({
  propTypes: {
    index: PropTypes.number,
    uuid: PropTypes.string,
    changeObject: PropTypes.func,
    contentSpace: PropTypes.string,
    data: PropTypes.object,
  },

  didRemoveWidget() {
    this.props.didRemoveWidget(this.props.index);
  },

  moveWidgetUp() {
    this.props.moveWidget(this.props.index, 'up');
  },

  moveWidgetDown() {
    this.props.moveWidget(this.props.index, 'down');
  },

  getDefaultProps: function() {
    return {
      index: 0,
      data: {
        target: null,
        uri: null,
        name: null,
        description: null,
      },
      uuid: '',
      changeObject: function() {},
    };
  },

  setPhoto: function(event) {
    var _this = this;
    var onFileSelect = function(uri) {
      MediaBrowserService.closeMediaBrowser();
      var object = _this.getWidgetObject();
      object.uri = uri;
      _this.props.changeObject(_this.props.index, object);
    };
    MediaBrowserService.openMediaBrowser(
      onFileSelect,
      null,
      this.props.mediaManager,
      false,
    );
  },

  getWidgetObject: function() {
    return {
      type: 'imagead',
      uri: this.props.data.uri,
      target: this.props.data.target,
      name: this.props.data.name,
      description: this.props.data.description,
      uuid: this.props.uuid,
    };
  },

  onChange: function() {
    var o = this.getWidgetObject();
    o.target = this.refs.target.value;
    o.name = this.refs.name.value;
    o.description = this.refs.description.value;
    this.props.changeObject(this.props.index, o);
  },

  render: function() {
    var contentHtml = null;
    if (!this.props.data.uri) {
      // ak nemame uri tak zobrazime plochu pre pridanie
      contentHtml = (
        <div onClick={this.setPhoto} className="add-image">
          <i className="fa fa-plus" />
        </div>
      );
    } else {
      // ak mame zadane uri tak zobrazime obrazok
      contentHtml = (
        <img
          onClick={this.setPhoto}
          style={{
            maxWidth: '100%',
            margin: '0 auto',
            display: 'block',
            cursor: 'pointer',
          }}
          src={'http://data.tvkosice.sk/cmdata/' + this.props.data.uri}
        />
      );
    }
    return (
      <div
        data-index={this.props.index}
        style={{ clear: 'both' }}
        className="panel panel-default widget-body"
      >
        <div className="panel-heading">
          <div className="btn-group">
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetUp}
              disabled={this.props.index === 0}
            >
              <i className="fa fa-arrow-up" />
            </button>
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetDown}
              disabled={this.props.isLast}
            >
              <i className="fa fa-arrow-down" />
            </button>
          </div>
          <span className="panel-title">
            <strong> {this.props.name}</strong>
          </span>
          <a
            onClick={this.didRemoveWidget}
            href="javascript:void(0);"
            className="btn btn-danger btn-sm pull-right"
          >
            <i className="fa fa-times" />
          </a>
        </div>
        <div className="panel-body form-horizontal">
          <div className="form-group">
            <label className="title control-label col-sm-2">Target URL</label>
            <div className="col-sm-10">
              <input
                onChange={this.onChange}
                value={this.props.data.target}
                type="text"
                placeholder="http://..."
                className="form-control"
                ref="target"
              />
            </div>
          </div>
          <div className="form-group">
            <label className="title control-label col-sm-2">Názov</label>
            <div className="col-sm-10">
              <input
                onChange={this.onChange}
                value={this.props.data.name}
                type="text"
                placeholder=""
                className="form-control"
                ref="name"
              />
            </div>
          </div>
          <div className="form-group">
            <label className="title control-label col-sm-2">Popis</label>
            <div className="col-sm-10">
              <input
                onChange={this.onChange}
                value={this.props.data.description}
                type="text"
                placeholder=""
                className="form-control"
                ref="description"
              />
            </div>
          </div>
          <div className="form-group">{contentHtml}</div>
        </div>
      </div>
    );
  },
});

export default ImageadWidget;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticleWidgets/ArticleImageadWidget.jsx